import type { ParserSnapshot } from '@/lib/types'
import { formatAgo, formatClock } from '@/lib/format'
import { HIGHLIGHT_PCT } from './model'
import { ClockIcon, FlameIcon, LayersIcon, LinkIcon } from '@/components/common/icons'
import { Metric } from '@/components/common/Metric'

interface MetricsRowProps {
  snapshot: ParserSnapshot | null
  nowMs: number
}

export function MetricsRow({ snapshot, nowMs }: MetricsRowProps) {
  const exCount = snapshot?.exchanges.length ?? 0
  const commonPairs = snapshot?.common_pairs ?? 0
  const highlight = snapshot?.funding_highlight_count ?? 0
  const updated = snapshot?.updated_ts_ms ?? 0

  return (
    <div className="metrics">
      <Metric
        label="Биржи"
        value={exCount}
        foot="подключено к парсеру"
        icon={<LayersIcon size={18} />}
        tone="accent"
        hint="Число бирж, подключённых к парсеру (берётся из реестра бирж движка, не задаётся вручную)."
      />
      <Metric
        label="Общих пар"
        value={commonPairs}
        foot="монет на ≥2 биржах"
        icon={<LinkIcon size={18} />}
        tone="info"
        hint="Монеты, которые торгуются минимум на 2 биржах — кандидаты на дельта-нейтральную связку (лонг на одной бирже, шорт на другой)."
      />
      <Metric
        label={`Фандинг > ${HIGHLIGHT_PCT}%`}
        value={highlight}
        foot="по размаху ставок"
        icon={<FlameIcon size={18} />}
        tone="pos"
        hint={`Сколько монет имеют размах ставок фандинга между биржами больше ${HIGHLIGHT_PCT}%. Это информационная скан-метрика обзора (по мейкерской комиссии), а не порог для входа — решение принимается на этапе расчёта прибыли по тейкерским издержкам.`}
      />
      <Metric
        label="Обновлено"
        value={<span style={{ fontSize: 20 }}>{formatAgo(updated, nowMs)}</span>}
        foot={updated ? `в ${formatClock(updated)}` : 'нет данных'}
        icon={<ClockIcon size={18} />}
        tone="muted"
        title={updated ? new Date(updated).toLocaleString('ru-RU') : undefined}
        hint="Когда движок последний раз пересобрал снимок парсера. Кнопка «Обновить» форсирует пересборку (работает и при выключенном боте)."
      />
    </div>
  )
}
